import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

const socialLinks = [
  {
    label: 'WhatsApp',
    href: 'https://wa.me/923424346670',
    handle: '+923424346670',
    color: '#34d399',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="#34d399">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
      </svg>
    ),
  },
  {
    label: 'LinkedIn',
    href: 'https://linkedin.com/in/shahid-ai-python',
    handle: 'shahid-ai-python',
    color: '#8B72FF',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="#8B72FF">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
  },
  {
    label: 'GitHub',
    href: 'https://github.com/Shahid-Sheimi',
    handle: 'Shahid-Sheimi',
    color: '#c4b5fd',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="#c4b5fd">
        <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z" />
      </svg>
    ),
  },
  {
    label: 'Email',
    href: 'mailto:shahidhosseinoff@gmail.com',
    handle: 'shahidhosseinoff@gmail.com',
    color: '#f87171',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f87171" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="4" width="20" height="16" rx="2" />
        <path d="m22 7-8.97 5.7a1.94 1.94 0 01-2.06 0L2 7" />
      </svg>
    ),
  },
];

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_9zt0bcs',
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'template_vjyucqf',
      { from_name: formData.name, from_email: formData.email, message: formData.message },
      process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'D-W_LMHiIfJxvjSyS'
    )
    .then(() => {
      setSubmitStatus('success');
      setFormData({ name: '', email: '', message: '' });
      setIsSubmitting(false);
      setTimeout(() => setSubmitStatus(null), 5000);
    })
    .catch((err) => {
      console.error(err);
      setSubmitStatus('error');
      setIsSubmitting(false);
      setTimeout(() => setSubmitStatus(null), 5000);
    });
  };

  return (
    <section className="contact-section" id="contacts">
      <div className="contact-container">
        <div className="contact-header">
          <div className="contact-eyebrow">Get in touch</div>
          <h2 className="contact-title">
            Let's build something <span className="highlight">together</span>
          </h2>
          <p className="contact-subtitle">
            Have a project in mind or want to explore an opportunity? I'm always open to discussing new ideas and collaborations.
          </p>
        </div>

        <div className="contact-grid">
          <div className="form-card">
            <h3 className="form-heading">Send a message</h3>

            {submitStatus === 'success' ? (
              <div className="success-state">
                <div className="success-icon-wrap">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#2dd4bf" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                </div>
                <h4>Message sent</h4>
                <p>Thanks for reaching out — I'll get back to you within 24 hours.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-field">
                    <label className="field-label">Your name</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="John Doe"
                      required
                      className="field-input"
                    />
                  </div>
                  <div className="form-field">
                    <label className="field-label">Email address</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="john@example.com"
                      required
                      className="field-input"
                    />
                  </div>
                </div>
                <div className="form-field">
                  <label className="field-label">Your message</label>
                  <textarea
                    name="message"
                    rows={5}
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Tell me about your project, requirements, or just say hello…"
                    required
                    className="field-input field-textarea"
                  />
                </div>
                <div className="form-footer">
                  <button type="submit" disabled={isSubmitting} className="submit-btn">
                    {isSubmitting ? (
                      <span className="spinner" />
                    ) : (
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="22" y1="2" x2="11" y2="13" />
                        <polygon points="22 2 15 22 11 13 2 9 22 2" />
                      </svg>
                    )}
                    {isSubmitting ? 'Sending…' : 'Send message'}
                  </button>
                  <span className="response-hint">Usually replies in 2–4 hours</span>
                </div>
                {submitStatus === 'error' && (
                  <p className="error-msg">Failed to send. Please try WhatsApp or email directly.</p>
                )}
              </form>
            )}
          </div>

          <div className="sidebar">
            <div className="avail-card">
              <div className="avail-badge">
                <span className="pulse-dot" />
                <span>Available for new projects</span>
              </div>
              <p className="avail-text">
                Open to freelance, contract, and full-time opportunities — short or long-term.
              </p>
            </div>

            <div className="links-card">
              <p className="links-label">Reach me directly</p>
              <div className="links-list">
                {socialLinks.map(({ label, href, handle, icon }) => (
                  <a key={label} href={href} target="_blank" rel="noopener noreferrer" className="direct-link">
                    {icon}
                    <span className="link-label">{label}</span>
                    <span className="link-handle">{handle}</span>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .contact-section {
          background: var(--bg);
          padding: 96px 5vw 88px;
        }

        .contact-container {
          max-width: 920px;
          margin: 0 auto;
        }

        .contact-header {
          text-align: center;
          margin-bottom: 56px;
        }

        .contact-eyebrow {
          display: inline-block;
          font-family: var(--ff-mono);
          font-size: 11px;
          letter-spacing: 0.1em;
          color: var(--accent);
          padding: 6px 16px;
          border: 1px solid var(--accent-dim);
          border-radius: 50px;
          background: var(--accent-dim);
          margin-bottom: 20px;
        }

        .contact-title {
          font-size: clamp(2rem, 4vw, 3rem);
          font-weight: 300;
          color: var(--text);
          line-height: 1.15;
          margin: 0 0 14px;
        }

        .contact-title .highlight {
          color: var(--accent);
          font-weight: 400;
        }

        .contact-subtitle {
          font-size: 0.975rem;
          color: var(--muted);
          max-width: 480px;
          margin: 0 auto;
          line-height: 1.8;
        }

        .contact-grid {
          display: grid;
          grid-template-columns: 1fr 340px;
          gap: 24px;
          align-items: start;
        }

        .form-card {
          background: var(--surface);
          border: 1px solid var(--border);
          border-radius: 16px;
          padding: 36px 36px 40px;
        }

        .form-heading {
          font-size: 0.9rem;
          font-weight: 500;
          color: var(--text);
          margin: 0 0 28px;
        }

        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
        }

        .form-field {
          margin-bottom: 18px;
        }

        .field-label {
          display: block;
          font-family: var(--ff-mono);
          font-size: 10px;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          color: var(--muted);
          margin-bottom: 8px;
        }

        .field-input {
          width: 100%;
          background: var(--bg);
          border: 1px solid var(--border);
          border-radius: 10px;
          padding: 12px 16px;
          color: var(--text);
          font-size: 0.9rem;
          outline: none;
          transition: border-color 0.2s;
          box-sizing: border-box;
          resize: none;
          font-family: inherit;
        }

        .field-input::placeholder { color: rgba(237, 233, 255, 0.3); }

        .field-input:focus {
          border-color: var(--accent);
          box-shadow: 0 0 0 3px rgba(139, 114, 255, 0.15);
        }

        .field-textarea { min-height: 120px; }

        .form-footer {
          display: flex;
          align-items: center;
          gap: 16px;
          margin-top: 8px;
        }

        .submit-btn {
          display: inline-flex;
          align-items: center;
          gap: 9px;
          padding: 12px 26px;
          background: var(--accent);
          color: #fff;
          border: none;
          border-radius: 9px;
          font-size: 0.875rem;
          font-weight: 500;
          cursor: pointer;
          transition: background 0.2s, transform 0.15s;
          font-family: inherit;
        }

        .submit-btn:hover:not(:disabled) {
          background: #7A5FF0;
          transform: translateY(-1px);
        }

        .submit-btn:disabled { opacity: 0.65; cursor: not-allowed; }

        .response-hint {
          font-size: 12px;
          color: var(--muted);
        }

        .error-msg {
          margin-top: 14px;
          font-size: 0.85rem;
          color: #f87171;
          text-align: center;
        }

        .spinner {
          width: 14px; height: 14px;
          border: 2px solid rgba(255,255,255,0.3);
          border-top-color: #fff;
          border-radius: 50%;
          animation: spin 0.7s linear infinite;
          display: inline-block;
        }

        @keyframes spin { to { transform: rotate(360deg); } }

        .success-state {
          text-align: center;
          padding: 40px 20px;
        }

        .success-icon-wrap {
          width: 56px; height: 56px;
          border-radius: 50%;
          background: rgba(45, 220, 180, 0.1);
          border: 1px solid rgba(45, 220, 180, 0.25);
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 18px;
        }

        .success-state h4 {
          font-size: 1.1rem;
          font-weight: 500;
          color: var(--text);
          margin: 0 0 8px;
        }

        .success-state p {
          font-size: 0.9rem;
          color: var(--muted);
          margin: 0;
        }

        .sidebar {
          display: flex;
          flex-direction: column;
          gap: 14px;
        }

        .avail-card {
          background: var(--surface);
          border: 1px solid var(--border);
          border-radius: 14px;
          padding: 22px;
        }

        .avail-badge {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 12px;
          color: var(--accent2);
          font-weight: 500;
          margin-bottom: 10px;
        }

        .pulse-dot {
          width: 7px; height: 7px;
          border-radius: 50%;
          background: var(--accent2);
          animation: pulse 2s ease-in-out infinite;
        }

        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.4} }

        .avail-text {
          font-size: 0.82rem;
          color: var(--muted);
          margin: 0;
          line-height: 1.7;
        }

        .links-card {
          background: var(--surface);
          border: 1px solid var(--border);
          border-radius: 14px;
          padding: 22px;
        }

        .links-label {
          font-family: var(--ff-mono);
          font-size: 10px;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          color: var(--muted);
          margin: 0 0 14px;
        }

        .links-list {
          display: flex;
          flex-direction: column;
          gap: 9px;
        }

        .direct-link {
          display: flex;
          align-items: center;
          gap: 11px;
          padding: 11px 14px;
          background: var(--bg);
          border: 1px solid var(--border);
          border-radius: 10px;
          text-decoration: none;
          transition: border-color 0.2s;
        }

        .direct-link:hover { border-color: var(--accent-dim); }

        .link-label {
          font-size: 0.85rem;
          color: var(--text);
        }

        .link-handle {
          font-size: 0.78rem;
          color: var(--muted);
          margin-left: auto;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 120px;
        }

        @media (max-width: 768px) {
          .contact-grid { grid-template-columns: 1fr; }
          .form-row { grid-template-columns: 1fr; }
          .form-card { padding: 28px 24px 32px; }
        }
      `}</style>
    </section>
  );
};

export default Contact;